import React from "react";
import { formateDate, renderStatus } from "../../../../Utils/CommonUtils";

function useAllTransactionColumn() {
  const alltransactionColumn = [
    {
      header: "Txn ID",
      accessorKey: "code",
      cell: (props) => (props.getValue() ? props.getValue() : "-"),
    },
    {
      header: "Order ID",
      accessorKey: "order_id",
      cell: (props) => (props.getValue() ? props.getValue() : "-"),
    },
    {
      header: "Payment Date",
      accessorKey: "payment_date",
      // cell: (props) => (props.getValue() ? formateDate(props.getValue()) : "-"),
    },
    {
      header: "Amount",
      accessorKey: "amount",
      cell: (props) => (props?.getValue() ? "₹ " + props?.getValue() : "-"),
    },
    {
      header: "Payment Status",
      accessorKey: "payment_status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
    },
  ];
  return { alltransactionColumn };
}

export default useAllTransactionColumn;
